<template>
    <div class="content w-chart">
        <div class="d-ins">
            <p>Your results on the Müller-Lyer illusion experiment</p>
            <div class="row">
                <div class="col-xl-6">
                    <p class="text-center cht-error-title">Error score</p>
                    <v-chart :options="option1"/>
                    <p class="text-center font-weight-bold">End shapes</p>
                </div>
                <div class="col-xl-6">
                    <p class="text-center cht-error-title">Error score</p>
                    <v-chart :options="option2"/>
                    <p class="text-center font-weight-bold">End shapes</p>
                </div>
            </div>
            <p>The charts above show the error scores for each of the end shapes. Graph A shows your results where the lines showed the same shapes. Graphs B shows your results where the lines showed different shapes.</p>
            <p>The higher the error score, the greater the difference in the line length, according to your adjustments.</p>
            <p>The illusion does not tend to work when the end shapes are the same, and so the columns should be much smaller on Graph A, in comparison to Graph B.</p>
            <p>You were also expected to have made fewer errors when the end shapes were straight lines or circles.</p>
        </div>
    </div>
</template>
<script>
var shapeLabels = {
    'a': require('@/assets/img/o1.jpg'),
    'b': require('@/assets/img/o2.jpg'),
    'c': require('@/assets/img/o3.jpg'),
    'd': require('@/assets/img/o4.jpg'),
    'e': require('@/assets/img/o5.jpg'),
    'f': require('@/assets/img/x1.jpg'),
    'g': require('@/assets/img/x2.jpg'),
    'h': require('@/assets/img/x3.jpg'),
    'i': require('@/assets/img/x4.jpg'),
    'j': require('@/assets/img/x5.jpg'),
};
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            max: 100,
            option1: {
                title: {
                    x: 'center',
                    text: 'Graph A'
                },
                xAxis: {
                    axisTick: { show: false },
                    type: 'category',
                    data: ['a', 'b', 'c', 'd', 'e'],
                    axisLabel: {
                        formatter: function (value) {
                            return '{' + value + '| }\n{value|' + value + '}';
                        },
                        margin: 20,
                        rich: {
                            value: {
                                lineHeight: 30,
                                align: 'center'
                            },
                            'a': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.a
                                }
                            },
                            'b': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.b
                                }
                            },
                            'c': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.c
                                }
                            },
                            'd': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.d
                                }
                            },
                            'e': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.e
                                }
                            }
                        }
                    }
                },
                yAxis: {
                splitLine: {
                    show: false
                },
                type: 'value',
                max: 75,
                min: 0,
                interval: 15
                },
                series: [{
                itemStyle: {
                    normal: {
                    barBorderColor: 'gray',
                    color: 'rgb(239, 184, 13)'
                    },
                    emphasis: {
                    color: 'rgb(239, 184, 13)'
                    }
                },
                data: [80, 12, 41, 60, 12],
                type: 'bar'
                }]
            },
            option2: {
                title: {
                    x: 'center',
                    text: 'Graph B'
                },
                xAxis: {
                    axisTick: { show: false },
                    type: 'category',
                    data: ['f', 'g', 'h', 'i', 'j'],
                    axisLabel: {
                        formatter: function (value) {
                            return '{' + value + '| }\n{value|' + value + '}';
                        },
                        margin: 20,
                        rich: {
                            value: {
                                lineHeight: 30,
                                align: 'center'
                            },
                            'f': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.f
                                }
                            },
                            'g': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.g
                                }
                            },
                            'h': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.h
                                }
                            },
                            'i': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.i
                                }
                            },
                            'j': {
                                height: 40,
                                align: 'center',
                                backgroundColor: {
                                    image: shapeLabels.j
                                }
                            }
                        }
                    }
                },
                yAxis: {
                splitLine: {
                    show: false
                },
                type: 'value',
                max: 75,
                min: 0,
                interval: 15
                },
                series: [{
                itemStyle: {
                    normal: {
                    barBorderColor: 'gray',
                    color: 'rgb(9, 30, 147)'
                    },
                    emphasis: {
                    color: 'rgb(9, 30, 147)'
                    }
                },
                data: [80, 12, 41, 60, 12],
                type: 'bar'
                }]
            }
        }
    },
    created() {
        this.option1.series[0].data[0] = this.getAverage('same', ['a1So', 'a1Lo', 'b1So', 'b1Lo'])
        this.option1.series[0].data[1] = this.getAverage('same', ['a2So', 'a2Lo', 'b2So', 'b2Lo'])
        this.option1.series[0].data[2] = this.getAverage('same', ['a3So', 'a3Lo', 'b3So', 'b3Lo'])
        this.option1.series[0].data[3] = this.getAverage('same', ['a4So', 'a4Lo'])
        this.option1.series[0].data[4] = this.getAverage('same', ['a5So', 'a5Lo'])

        this.option2.series[0].data[0] = this.getAverage('conflict', ['a1Sx', 'a1Lx'])
        this.option2.series[0].data[1] = this.getAverage('conflict', ['a2Sx', 'a2Lx'])
        this.option2.series[0].data[2] = this.getAverage('conflict', ['a3Sx', 'a3Lx'])
        this.option2.series[0].data[3] = this.getAverage('conflict', ['a4Sx', 'a4Lx'])
        this.option2.series[0].data[4] = this.getAverage('conflict', ['a5Sx', 'a5Lx'])
    },
    methods: {
        getAverage(end, angles) {
            var sum = 0
            var ave = 0
            for (const angle in angles) {
                sum += this.ends[end][angles[angle]].score
                if (this.ends[end][angles[angle]].score > this.max) {
                    this.max = this.ends[end][angles[angle]].score
                }
            }
            ave = sum / angles.length
            ave = ave > 75 ? 75 : ave
            return ave
        }
    },
    computed: {
        ...mapGetters([
            'getData'
        ]),
        ends () {
            return this.getData('ends')
        }
    }
}
</script>
